import Ankle from './Ankle/Ankle'
import { ReactAnkleProps } from './types'
import withAEM from '../../hoc/withAEM'

const ReactAnkle = (props: ReactAnkleProps): JSX.Element => {
  const ReactAnkleWithAEM = withAEM(Ankle)
  return <ReactAnkleWithAEM {...props} compName={'React Ankle'} />
}
export default ReactAnkle
